import { VERTRAEGE_KUENDIGEN } from '@/domain/vertraege/shared/hooks/graphql/mutations';
import {
  Vertraege_KuendigenMutation,
  Vertraege_KuendigenMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useVertraegeKuendigen() {
  const [execute, result] = useMutation<
    Vertraege_KuendigenMutation,
    Vertraege_KuendigenMutationVariables
  >(VERTRAEGE_KUENDIGEN, {
    refetchQueries: ['GetBenachrichtigungen'],
  });

  const vertraegeKuendigen = useCallback(
    (variables: Vertraege_KuendigenMutationVariables) => {
      return execute({ variables });
    },
    [execute],
  );
  return [vertraegeKuendigen, result] as const;
}
